import { render, staticRenderFns } from "./BookingTable.vue?vue&type=template&id=ec146e60&scoped=true"
import script from "./BookingTable.vue?vue&type=script&lang=js"
export * from "./BookingTable.vue?vue&type=script&lang=js"
import style0 from "./BookingTable.vue?vue&type=style&index=0&id=ec146e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec146e60",
  null
  
)

export default component.exports